export default __webpack_public_path__ + "static/media/verification-white.0a37af90.svg";